import {
  STORE_STEP,
  STORE_ACK_NUMBER,
  STORE_ACCOUNT_TYPE,
  GET_PERSONAL_DETAILS_SUCCESS,
  GET_KYC_DETAILS_SUCCESS,
  GET_FATCA_DETAILS_SUCCESS,
  GET_BANK_DETAILS_SUCCESS,
  GET_NOMINEE_LIST_SUCCESS,
  GET_NPS_SCHEME_DETAILS_SUCCESS,
  CLEAR_NEW_SUBSCRIBER_DATA,
  GET_AADHAAR_DETAILS_SUCCESS,
  GET_NPS_FUND_INVESTMENT_CHOICES_SUCCESS,
  STORE_KYC_KTRACK_DETAILS,
  GET_PREVIEW_SUCCESS,
  STORE_SUBSCRIBER_DATA,
} from "././../types/newSubscriber";

const initialState = {
  step: 0,
  personalDetails: {},
  kycDetails: {},
  aadhaarDetails: {},
  fatcaDetails: {},
  bankDetails: {},
  nomineeList: {},
  npsSchemeDetails: {},
  npsFundChoices: {},
  ePranKit: {},
  kycKtrackDetails: {},
  summary: {},
  ackNumber: "",
  preview: {},
  accountType: "",
  subscriberData: {},
};

export function newSubscriber(state = initialState, action) {
  switch (action.type) {
    case STORE_STEP:
      return { ...state, step: action.body };
    case STORE_ACK_NUMBER:
      return { ...state, ackNumber: action.body };
    case STORE_SUBSCRIBER_DATA:
      return { ...state, subscriberData: action.body };
    case STORE_ACCOUNT_TYPE:
      return { ...state, accountType: action.body };
    case GET_PERSONAL_DETAILS_SUCCESS:
      return { ...state, personalDetails: action.body };
    case GET_KYC_DETAILS_SUCCESS:
      return { ...state, kycDetails: action.body };
    case GET_FATCA_DETAILS_SUCCESS:
      return { ...state, fatcaDetails: action.body };
    case GET_BANK_DETAILS_SUCCESS:
      return { ...state, bankDetails: action.body };
    case GET_NOMINEE_LIST_SUCCESS:
      return { ...state, nomineeList: action.body };
    case GET_NPS_SCHEME_DETAILS_SUCCESS:
      return { ...state, npsSchemeDetails: action.body };
    case GET_AADHAAR_DETAILS_SUCCESS:
      return { ...state, aadhaarDetails: action.body };
    case GET_NPS_FUND_INVESTMENT_CHOICES_SUCCESS:
      return { ...state, npsFundChoices: action.body };
    case STORE_KYC_KTRACK_DETAILS:
      return { ...state, kycKtrackDetails: action.body };
    case GET_PREVIEW_SUCCESS: {
      const { data, statusCode } = action.body;
      if (statusCode === "10000") {
        const {
          objPersonalDetails,
          objKYCDetails,
          objBankDetails,
          objSchemDetails,
          objNomineeDetails,
        } = data;
        const preview = {
          personalDetailsPreview: objPersonalDetails[0],
          kycDetailsPreview: objKYCDetails[0],
          bankDetailsPreview: objBankDetails[0],
          schemeDetailsPreview: objSchemDetails,
          nomineeDetailsPreview: objNomineeDetails[0],
          photoDetailsPreview: {},
        };
        return { ...state, preview };
      } else {
        return state;
      }
    }
    case CLEAR_NEW_SUBSCRIBER_DATA:
      return initialState;
    default:
      return state;
  }
}
